<ng-template #template>
  @let res = resource();
  <soft-resource-container
    class="block overflow-hidden"
    [ngStyle]="dataContainerStyles() ?? {}"
    [ngClass]="dataContainerClass() ?? 'max-h-[80vh] sm:max-h-[50vh]'"
    [resource]="res"
  >
    <soft-master-detail
      [data]="items() ?? []"
      [masterTemplate]="masterTemplate()"
      [detailTemplate]="detailTemplate()"
      [selected]="selectedData()"
      (selectedChange)="this.selectionChange.emit($event)"
    >
    </soft-master-detail>
  </soft-resource-container>
</ng-template>
